import { z } from 'zod';

// UI languages = translation targets. Czech first (home market), then the eight most
// widely spoken languages we support. Adding one = adding a locale file + this list.
export const UI_LANGUAGES = ['cs', 'en', 'es', 'fr', 'pt', 'de', 'ru', 'hi'] as const;
export const uiLanguage = z.enum(UI_LANGUAGES);
export type UiLanguage = z.infer<typeof uiLanguage>;

/** Native names for the language switcher (never translated). */
export const LANGUAGE_NAMES: Record<UiLanguage, string> = {
  cs: 'Čeština',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  pt: 'Português',
  de: 'Deutsch',
  ru: 'Русский',
  hi: 'हिन्दी',
};

export const premiumStatus = z.object({
  active: z.boolean(),
  // ISO timestamp of premium_until, null when the user never had premium
  until: z.string().nullable(),
});
export type PremiumStatus = z.infer<typeof premiumStatus>;

export const translationContentStatus = z.enum(['none', 'pending', 'ok', 'failed']);

/** Translation of one article into the requesting user's language. The original stays
 * in the article fields; the client decides which to show. */
export const translationDto = z.object({
  lang: uiLanguage,
  // detected language of the original (ISO 639-1), null when detection failed
  sourceLang: z.string().nullable(),
  title: z.string(),
  summary: z.string().nullable(),
  // null until the full text was translated on demand
  contentHtml: z.string().nullable(),
  contentStatus: translationContentStatus,
});
export type TranslationDto = z.infer<typeof translationDto>;

export const translateErrorCode = z.enum([
  'premium_required',
  'translation_disabled',
  'same_language',
  'translation_capacity',
  'not_found',
]);
export type TranslateErrorCode = z.infer<typeof translateErrorCode>;

export const muteKind = z.enum(['word', 'tag']);
export type MuteKind = z.infer<typeof muteKind>;
